export default {
  name: 'xiangtan',
  adcode: '430300',
  mapName: '湘潭市',
  geoJsonPath: 'hunanmap/430300.json',
  backgroundImage: {
    png: '湘潭市_430300.png',
    webp: '湘潭市_430300.webp'
  },
  echartsMapStyle: {
    width: '870px',
    height: '676px',
    marginTop: 'auto',
    marginBottom: '76px',
  },
  imageSize: {
    width: 4016,
    height: 3118
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.29, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.002,  // X轴偏移百分比
      y: 0.002  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['湘潭市区', '湘潭县', '湘乡市', '韶山市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    '湘潭市区': [112.8270, 27.9160],
    '湘潭市': [112.8270, 27.9160],
    '湘潭县': [112.7510, 27.6380],
    '湘乡市': [112.3250, 27.7790],
    '韶山市': [112.4670, 27.9320]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '湘潭市') return '湘潭市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '雨湖区': '430302',
    '岳塘区': '430304',
    '湘潭县': '430321',
    '湘乡市': '430381',
    '韶山市': '430382'
  }
}